'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidPeople = function IoAndroidPeople(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.8 18.1c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7 4.9 2.2 4.9 4.7-2.2 4.7-4.9 4.7z m-12.6 0c-2.7 0-4.9-2.1-4.9-4.7s2.2-4.6 4.9-4.6 4.7 2.1 4.7 4.6-2.1 4.7-4.7 4.7z m0 3.5c3.7 0 11.3 1.8 11.3 5.4v4.3h-22.5v-4.3c0-3.6 7.4-5.4 11.2-5.4z m12.6 0.8c3.8 0 11.2 1 11.2 4.6v4.3h-10v-4.3c0-2.3-0.7-3.2-2.5-4.5 0.5-0.1 0.9-0.1 1.3-0.1z' })
        )
    );
};

exports.default = IoAndroidPeople;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-people.js
// module id = 1917
// module chunks = 0